import { useMemo } from 'react';

import { FullProject } from 'entities';

import { Column, Skeleton } from 'components/Blocks';

import { useContainerScroll } from 'hooks/appWrapperScroll';

import SingleProject from './SingleProject';

interface ProjectsProps {
  projects: FullProject[];
  loading?: boolean;
}

const AVG_PROJECT_HEIGHT = 130;

export function ProjectList({ projects, loading }: ProjectsProps) {
  const scrollDistance = useContainerScroll();

  const lastProjectToRender = useMemo(() => {
    const MIN_AMOUNT = 20;

    const extraRendersBasedOnScroll = Math.round(scrollDistance / AVG_PROJECT_HEIGHT);

    return MIN_AMOUNT + extraRendersBasedOnScroll;
  }, [scrollDistance]);

  if (loading) return <Skeleton height={110} quantity={6} />;

  return (
    <Column styles={{ minHeight: `${projects.length * AVG_PROJECT_HEIGHT}px` }}>
      {projects.slice(0, lastProjectToRender).map((project) => (
        <SingleProject key={project.id} project={project} />
      ))}
    </Column>
  );
}
